export default "__VITE_PUBLIC_ASSET__40394392__"